import { SELECT_STATE_ALL_PRODUCTS, SELECT_STATE_PART_PRODUCTS } from '../directory-products/DirectoryProductsActions'

export const FETCH_DIRECTORY_COMPANIES = "FETCH_DIRECTORY_COMPANIES"
export const FETCHED_DIRECTORY_COMPANIES = "FETCHED_DIRECTORY_COMPANIES"
export const SEARCH_DIRECTORY_COMPANIES = "SEARCH_DIRECTORY_COMPANIES"
export const SELECT_DIRECTORY_COMPANY = "SELECT_DIRECTORY_COMPANY"
export const SEARCH_DIRECTORY_COMPANIES_ANYWARE = "SEARCH_DIRECTORY_COMPANIES_ANYWARE"
export const SEARCH_DIRECTORY_COMPANIES_START_WITH = "SEARCH_DIRECTORY_COMPANIES_START_WITH"
export const ANYWHERE_PARAM_COMPANY = "ANYWHERE_PARAM_COMPANY"
export const START_WITH_PARAM = "START_WITH_PARAM"
export const FETCH_DETAILS_FOR_SELECTED_COMPANY = "FETCH_DETAILS_FOR_SELECTED_COMPANY"
export const FETCHED_DETAILS_FOR_SELECTED_COMPANY = "FETCHED_DETAILS_FOR_SELECTED_COMPANY"

export function fetchIfNededDirectoryCompanies(first) {


  return (dispatch, getState) => {

    // if (getState().dataResultsReducer.dataResults) {
    //   return;
    // }

    dispatch(fetchDirectoryCompanies(first, getState().internationalizationReducer.activeLangCode))

    let inputBody = {};
    inputBody.paging = {
      current_page: getState().directorySearchDataReducer.currentPage,
      items_per_page: 20,
      lang: "en"
    }

    let directoryIsicsSelectionStatusAll = false;
    let directoryIsicsSelectedCount = getState().directoryIsicsReducer.isics.filter(t => t.selected).length;
    if (directoryIsicsSelectedCount === getState().directoryIsicsReducer.isics.length)
      directoryIsicsSelectionStatusAll = true

    if (directoryIsicsSelectionStatusAll) {
      inputBody = {
        ...inputBody,
        isicsSelection: "all"
      }
    } else {
      inputBody = {
        ...inputBody,
        isics: getState().directoryIsicsReducer.isics.filter(x => x.selected).map(x => ({ id: x.id })),
        isicsSelection: "part"
      }
    }

    let directoryRegionsSelectionStatusAll = false;
    let directoryRegionsSelectedCount = getState().directoryRegionsReducer.regions.filter(t => t.selected).length;
    if (directoryRegionsSelectedCount === getState().directoryRegionsReducer.regions.length)
      directoryRegionsSelectionStatusAll = true

    if (directoryRegionsSelectionStatusAll) {
      inputBody = {
        ...inputBody,
        regionsSelection: "all"
      }
    } else {
      inputBody = {
        ...inputBody,
        regions: getState().directoryRegionsReducer.regions.filter(x => x.selected).map(x => ({ id: x.id })),
        regionsSelection: "part"
      }
    }

    if(getState().directoryProductsReducer.selectionState === SELECT_STATE_PART_PRODUCTS) {
      inputBody.productSelection = SELECT_STATE_PART_PRODUCTS
      inputBody.products = getState().directoryProductsReducer.selectedRows.map(x => x.id)
    } else {
      inputBody.productSelection = SELECT_STATE_ALL_PRODUCTS
    }

    inputBody.search = {
      anyware: getState().directorySearchDataReducer.searchAnywhereParam,
      startingWith: getState().directorySearchDataReducer.startWithParam
    }

    return fetch('/ndap/directory/search', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        lang: getState().directorySearchDataReducer.activeLangCodeOfPages 
      },
      body: JSON.stringify(inputBody),
    }).then((response) => {
      if (!response.ok)
        throw Error(response.statusText)
      return response
    }).then((response) => response.json())
      .then((responseJson) => {
        // responseJson.unshift(["Activity", "Indicators", "Regions", "Value", "Years"]);
        dispatch(fetchedDirectoryCompanies(responseJson))
      })
      .catch((error) => {
        console.error(error);
      })
  }
}

export function fetchDirectoryCompanies(first, activeLangCode) {
  return { type: FETCH_DIRECTORY_COMPANIES, first, activeLangCode };
}

export function fetchedDirectoryCompanies(directoryCompanies) {
  return { type: FETCHED_DIRECTORY_COMPANIES, directoryCompanies }
}

export function selectDirectoryCompany(directoryCompanyId) {
  return { type: SELECT_DIRECTORY_COMPANY, directoryCompanyId }
}

export function searchAnywhere(searchAnywhereParam) {
  return { type: ANYWHERE_PARAM_COMPANY, searchAnywhereParam }
}

export function startWith(startWithParam) {
  return { type: START_WITH_PARAM, startWithParam }
}

export function fetchIfNeededDetailsForSelectedCompany() {

  return (dispatch, getState) => {

    dispatch(fetchDetailsForSelectedCompany())

    return fetch('/ndap/data/company/' + getState().directorySearchDataReducer.directoryCompanies.filter(x => x.selected)[0].id, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        lang: getState().internationalizationReducer.activeLangCode
      }
    }).then((response) => {
      if (!response.ok)
        throw Error(response.statusText)
      return response
    }).then((response) => response.json())
      .then((responseJson) => {
        // responseJson.unshift(["Activity", "Indicators", "Regions", "Value", "Years"]);
        dispatch(fetchedDetailsForSelectedCompany(responseJson))
      })
      .catch((error) => {
        console.error(error);
      })
  }
}

export function fetchDetailsForSelectedCompany() {
  return { type: FETCH_DETAILS_FOR_SELECTED_COMPANY }
}

export function fetchedDetailsForSelectedCompany(companyDetails) {
  return { type: FETCHED_DETAILS_FOR_SELECTED_COMPANY, companyDetails }
}


// WEBPACK FOOTER //
// ./src/features/modules/directory-of-manufactory/directory-search-data/DirectorySearchDataActions.js